import {
  EnvironmentProviders,
  makeEnvironmentProviders,
  Signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@jsverse/transloco';
import {
  addTenantIdsToUrl,
  AuthFacade,
  AuthStrategies,
  Tenant,
  TenantService,
} from '@mds/ngx-auth';
import { LocalizationService } from '@mds/ngx-core';
import {
  MDS_LAYOUT_NAVIGATION_ITEMS,
  NavigationChildItem,
  NavigationItem,
} from '@mds/ngx-layout';
import { filter, map, switchMap } from 'rxjs';
import { untranslatedNavigationItems } from '../models/navigation-items.model';

export function provideNavigationItems(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: MDS_LAYOUT_NAVIGATION_ITEMS,
      useFactory: navigationGroupsFactory,
      deps: [LocalizationService, TranslocoService, TenantService, AuthFacade],
    },
  ]);
}

export function navigationGroupsFactory(
  localizationService: LocalizationService,
  translateService: TranslocoService,
  tenantService: TenantService,
  authFacade: AuthFacade,
): Signal<NavigationItem[]> {
  return toSignal(
    localizationService.translationsLoaded$.pipe(
      filter((loaded) => loaded),
      switchMap(() => translateService.langChanges$),
      switchMap(() => authFacade.isAuthenticated$(AuthStrategies.Tenancy)),
      filter((isAuthenticated) => isAuthenticated),
      map(() => {
        const tenant = tenantService.getTenant();
        return untranslatedNavigationItems.map((m) =>
          tenantToMenuMap(tenant, {
            ...m,
            label: translateService.translate(m.label),
          }),
        );
      }),
    ),
    { initialValue: [] },
  );
}

function tenantToMenuMap(
  tenant: Tenant | undefined,
  item: NavigationChildItem,
): NavigationItem {
  const url = item.link;

  const tenantLink =
    item.link && tenant
      ? addTenantIdsToUrl(tenant.branchId, tenant.organizationId, url)
      : undefined;

  return {
    ...item,
    link: tenantLink ?? '',
  };
}
